//选择检测方法
import React from 'react'
import { connect } from 'react-redux'

import { hasChangedValues } from '../../public/utility/formValues'
class SelectMethodDetail extends React.Component {
    state = {
        errorMessage: null,
        id: this.props.id || 0,
    }

    componentDidMount = () => {
        this.doGetSelectMethod('')
    }

    doGetSelectMethod = (searchString = '') => {
        Tyan.doPostEvent('GetSelectMethod', {
            data: {
                id: this.state.id,
                strQuery: searchString
            },
            onEnd: ({ errorMessage, initValues基本信息, initValues检测方法 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                else {
                    this.setState({ initValues基本信息, changedValues检测方法: {}, initValues检测方法 })
                }
            }
        })
    }

    handlerSave = () => {
        const { id, changedValues检测方法 } = this.state
        const { onSave, onClose } = this.props

        var list = changedValues检测方法['检测方法-added']
        // console.log('list', list)
        var strMethodName = changedValues检测方法[`检测方法[${list[0]}].检测方法`]
        // console.log('strMethodName', strMethodName)
        // return
        onSave && onSave(strMethodName)
        onClose && onClose()
    }

    bCanSave = () => {
        const { changedValues检测方法 } = this.state
        return changedValues检测方法['检测方法-added'] !== null && changedValues检测方法['检测方法-added'].length === 1
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', () => {
            onClose && onClose()
        })
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues检测方法, initValues检测方法 } = this.state
        console.log('changedValues检测方法', changedValues检测方法)
        return [
            {
                _checkgrid: '', name: '检测方法', rowNumbers: false, height: '100%', minRows: 10, minWidth: '90%',
                itemsValues: initValues基本信息, onSearch: this.doGetSelectMethod,
                ignore: [],
                columns: [
                    { _text: '检测方法', minWidth: 300, flex: 2, },
                    { _text: '标准编号', minWidth: 150, flex: 1, },
                    { _text: '标准名称', minWidth: 150, flex: 1, },
                ],
            }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息 } = this.state

        if (errorMessage) return Tyan.pubForm.showError(errorMessage)

        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth={'1400px'}
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged() || !this.bCanSave() },
                    { _button: this.bChanged() ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '检测方法', _fieldset: this.fieldset基本信息(), fullblock: true },
                ]
            }
        />
    }
}

export default SelectMethodDetail